import { render, staticRenderFns } from "./formQuestion.vue?vue&type=template&id=0c2d1b9f&scoped=true&"
import script from "./formQuestion.vue?vue&type=script&lang=ts&"
export * from "./formQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./formQuestion.vue?vue&type=style&index=0&id=0c2d1b9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d1b9f",
  null
  
)

export default component.exports